import React from 'react';
import List from "@material-ui/core/List";

const SarasList = (props)=>{
    return(
        <List 
            component={props.component} 
            style={props.style} 
            dense={props.dense || false}
            className={props.className}
        >
            {props.children}
        </List>
    )
}

export default SarasList;
